
import styled from "styled-components";
import bottomImage from "../../../../../../assets/images/Unionlogo_hidden.svg";

const StyleWrapper = styled.div`
    // height: 15.625rem;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: column;
    justify-content: start;
    align-items: flex-start;
    padding: 24px;
    isolation: isolate;
    // width:23%;
    background: #FFFFFF;
    border: 1px solid #D9DCE1;
    border-radius: 12px;
    order: 0;
    align-self: stretch;
    z-index: 0;
    flex: 1 1 0px;
    margin-bottom: 1rem;
    position: relative;
    .price{
        color: ${props => props.businessColor ? props.businessColor : '#6B47F5'};

    }
    .title{
        font-style: normal;
        font-weight: 800;
        font-size: 20px;
    }
    .sub-title{
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #455560;
        opacity: 0.8;
        text-align:start

    }

    .p-radiobutton{
        width:30px;
        height:30px;

        .p-radiobutton-box{
            border:none;
            background:#F2F3F5;
            width:100%;
            height:100%;
        }
    }

    .actions{
        margin-top:auto;
        margin-bottom:0;
    }
    &.mpc_chip_wrap_div {
        margin-top: 1.1rem;
        .recomended {
            position: absolute;
    
            background-color: #312e52;

            border-radius: 1rem 1rem 0 0;
            height: 34px;
            bottom: -34px;
            display: flex;
            align-items: center;
            padding: 0 2.8rem;
            left: 15px;
            transform: rotate(180deg);
            &::before {
                content: "";
                display: block;
                position: absolute;
                bottom: -5px;
                left: 65px;
                width: 10px;
                height: 10px;
                background-color: #1A1C1F;
                z-index: -1;
                margin-left: auto;
                margin-right: auto;
                text-align: center;
                transform: rotate(45deg);
            }

            .mpc_chip_drive {
                background-color: #FFFFFF;
                border-radius: 1rem;
                // height: 25px;
                // display: flex;
                // align-items: center;
                p {
                    color: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
                    padding: 0 0.5rem;
                }
            }
            .mpc_chip_txt {
                p {
                    color: #fff;
                    font-weight: 400;
                    font-size: 0.75rem;
                    transform: rotate(180deg);
                }
            }
        }


        .mpc_chip {
            position: absolute;
            background-color: #1A1C1F;
            border-radius: 1rem 1rem 0 0;
            height: 34px;
            top: -34px;
            display: flex;
            align-items: center;
            padding: 0 0.5rem;
            left: 15px;

            &::before {
                content: "";
                display: block;
                position: absolute;
                bottom: -5px;
                left: 65px;
                width: 10px;
                height: 10px;
                background-color: #1A1C1F;
                z-index: -1;
                margin-left: auto;
                margin-right: auto;
                text-align: center;
                transform: rotate(45deg);
            }

            .mpc_chip_drive {
                background-color: #FFFFFF;
                border-radius: 1rem;
                // height: 25px;
                // display: flex;
                // align-items: center;
                p {
                    color: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
                    padding: 0 0.5rem;
                }
            }
            .mpc_chip_txt {
                p {
                    color: #fff;
                    font-weight: 400;
                    font-size: 0.75rem;
                    padding: 0 6px;
                }
            }
        }
    }

    &.active{
        background: url(${bottomImage}), ${props => props.businessColor ? props.businessColor : '#6B47F5'};
        background-repeat: no-repeat;
        background-position: right bottom;
        position: relative;
        .price{
            color: #FFF;
        }
        &> *{
            color:white;
        }
        .p-radiobutton{
            .p-radiobutton-box.p-highlight{
                background:white !important;
            }

            .p-radiobutton-icon{
                background: black;
                width: 11px !important;
                height: 11px !important;
            }
        }
        .beforeDiscount{
            color: #fff
        }
    }
    &.small_card{
        padding: .75rem;
    }
    @media screen and (max-width: 600px) {
        padding: 0;
        border: unset;
        box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
        border-radius: 8px;

        &.mobile_product_card {
            margin-top: 24px;
            .recomended {
                position: absolute;
                background-color: #312e52;
                border-radius: 1rem 1rem 0 0;
                height: 34px;
                bottom: -34px;
                display: flex;
                align-items: center;
                padding: 0 2.8rem;
                left: 15px;
                transform: rotate(180deg);
                &::before {
                    content: "";
                    display: block;
                    position: absolute;
                    bottom: -5px;
                    left: 65px;
                    width: 10px;
                    height: 10px;
                    background-color: #1A1C1F;
                    z-index: -1;
                    margin-left: auto;
                    margin-right: auto;
                    text-align: center;
                    transform: rotate(45deg);
                }
                .mpc_chip_txt {
                    p {
                        color: #fff;
                        font-weight: 400;
                        font-size: 0.75rem;
                        padding: 0 6px;
                        transform: rotate(180deg);
                    }
                }
                .fm-tawuniya{
                    color: white;
                }
            }    
            .mpc_chip {
                position: absolute;
                background-color: #1A1C1F;
                border-radius: 1rem 1rem 1rem 0;
                height: 34px;
                top: -34px;
                display: flex;
                align-items: center;
                padding: 0 0.5rem;

                &::before {
                    content: "";
                    display: block;
                    position: absolute;
                    bottom: -8px;
                    left: 0;
                    width: 10px;
                    height: 10px;
                    background-color: #1A1C1F;
                    z-index: -1;
                    margin-left: auto;
                    margin-right: auto;
                    text-align: center;
                }

                .mpc_chip_drive {
                    background-color: #FFFFFF;
                    border-radius: 1rem;
                    // height: 25px;
                    // display: flex;
                    // align-items: center;
                    p {
                        color: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
                        padding: 0 0.5rem;
                    }
                }
                .mpc_chip_txt {
                    p {
                        color: #fff;
                        font-weight: 400;
                        font-size: 0.75rem;
                        padding: 0 6px;
                    }
                }
            }
            .mpc_div {
                padding: 0.5rem 1rem;
                width: 100%;
                border-radius: 8px;
                background-color: #fff;

                hr {
                    margin: 10px 0;
                }
                &.mpc_div_active {
                    background-color: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
                    width: 100%;

                    .mpc_div_bottom {
                        .mpcdb_text {
                            color: #fff;
                        }
                    }

                    .sub-title {
                        color:white
                    }
                    hr {
                        border-color:white
                    }

                    .beforeDiscount{
                        color: #ccc
                    }
                }
                .mpc_div_top {
                    display: flex;
                    align-items: flex-start;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 100%;
                    gap: 0.5rem;
                    .mpc_div_top_price {
                        display: flex;
                        flex-direction: column;
                        .price {
                            margin-bottom: -2px;
                            font-weight: bold;
                            font-size: 1.75rem !important;
                        }
                    }
                }
                .mpc_div_bottom {
                    display: flex;
                    justify-content: flex-end;

                    .mpcdb_text {
                        color: #455560;
                        font-weight: 400;
                        font-size: 0.8rem;
                        padding: 0 4px;
                    }
                }
            }
            .mpc_active {
                // background-color: #fff;
                // border-radius: 0 0 8px 8px;
                width: 100%;
                padding: 1rem;
                .mpc_active_txt {
                    color: #455560;
                    font-size: 0.875rem;
                    font-weight: 400;
                }

                .mpc_active_tags_wrap {
                    width: 100%;
                    overflow: scroll;
                    margin-top: 8px;
                    .mpc_active_tags {
                        display: flex;
                        gap: 5px;
                        // overflow: scroll;
                        .mpc_active_tag {
                            display: flex;
                            align-items: center;
                            background-color: #F0F5F8;
                            border-radius: 1rem;
                            width: fit-content;
                            justify-content: center;
                            padding: 0.2rem 0.7rem;
    
                            .mpc_active_txt {
                                padding: 0 4px;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }
        }
        &.mobile_product_card_chip {
            margin-top: 2rem;
        }
        &.active {
            background: unset;
            background-color: #fff;
        }

        // arabic styles
        &.mobile_product_card_ar {
            .mpc_chip {
                border-radius: 1rem 1rem 0 1rem;
                &::before {
                    left: unset;
                    right: 0;
                }
            }
        }
    }
    .beforeDiscount{
        text-decoration: line-through;
        color: #888;
    }
`;

export default StyleWrapper;
